'use strict';

const AngularHelpers=require('../../../../dist-es6/client/angularCommon/angularHelpers');

module.exports=AngularHelpers.registerModule({
name:'fdc.features.flightMonitor',
dependencies:['ui.router'],
configs:[
require('./flightMonitorConfig')],

components:[
require('./flightMonitorController')]});
//# sourceMappingURL=index.js.map
